import { render, staticRenderFns } from "./JAnimateDemo.vue?vue&type=template&id=b79d0c96&scoped=true"
import script from "./JAnimateDemo.vue?vue&type=script&lang=js"
export * from "./JAnimateDemo.vue?vue&type=script&lang=js"
import style0 from "./JAnimateDemo.vue?vue&type=style&index=0&id=b79d0c96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79d0c96",
  null
  
)

export default component.exports